/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import React, {memo} from 'react';
import {makeStyles} from '@material-ui/core';
import {translate} from '@ion/core/src/locale/locale';
import Device from '@ion/core/src/services/Device';
import CardItemRow from '@ion/dls/src/layout/CardItemRow';
import {DLSTheme} from '@ion/dls/src/types/types';
import {resolveValue} from '@ion/dls/src/utils/ComponentUtils';
import useDeviceFields from '@ion/query/src/hooks/useDeviceFields';

interface DeviceAdditionalInfoContentProps {
  device: Device;
}

const useStyles = makeStyles((theme: DLSTheme) => {
  return {
    content : {
      padding : '0 15px'
    }
  };
});

const DeviceAdditionalInfoContent = ({
  device
}: DeviceAdditionalInfoContentProps) => {
  const classes  = useStyles();
  const deviceId = device?.getAssetValue('id');
  const queryData = useDeviceFields({deviceId: deviceId?.toString()});
  const {
    name,
    status,
    serialNumber,
    typeName
  } = queryData?.device || {};

  const fields = [
    {
      label : translate('tracking:assetDetail.additionalDeviceInfo.name'),
      value : name
    },
    {
      label : translate('tracking:assetDetail.additionalDeviceInfo.type'),
      value : typeName
    },
    {
      label : translate('tracking:assetDetail.additionalDeviceInfo.esn'),
      value : serialNumber
    },
    {
      label : translate('tracking:assetDetail.additionalDeviceInfo.status'),
      value : status
    }
  ];

  return (
    <div className={classes.content}>
      {fields.map(({label, value}) => (
        <CardItemRow key={label}
          value={resolveValue(value)}
          label={label}
          isBottomMargin={false}
          isTextRightAligned
          isCondensedVariant />
      ))}
    </div>
  );
};

export default memo(DeviceAdditionalInfoContent);
